
<template>
      <div>
      <form  data-vv-scope="submittForm">
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group">
              <template v-if="!callFromPetitionerDetails">
                <p v-if="!checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId')">
                  Are you sure you want to Add I-9 E-Verify Client ID?
                </p>
                <p  v-else>Are you sure you want to file the I-9 in E-Verify Portal?</p>
              </template>
              <immiInput v-if="!checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId')" :wrapclass="'md:w-full'" :allowUpperCase="true" :display="true" :required="true" :onlyNumbers="true" :allowFloatingPoint="false" :fieldsArray="[]" maxvalueData="alpha_num|min:7|max:7" cid="eVerifyNumber" formscope="submittForm" v-model="eVerifyNumber" :maxLength="7"   :fieldName="'eVerifyNumber'"   label="I-9 E-Verify Client ID" placeHolder="I-9 E-Verify number" />
                </div>
              </div>
            </div>
          </div>
          <div class="popup-footer">
            <figure v-if="loading" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
            <vs-button color="dark" @click="hideMe" class="cancel" type="filled">Cancel</vs-button>
            <vs-button color="success" @click="submitForm()" class="save" type="filled">{{eVerifyUpdate ? 'Update' : 'Submit'}}</vs-button>
            <!-- <vs-button v-if="checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId')" color="success" @click="submitToEverify()" class="save" type="filled">Yes</vs-button> -->
          </div>
         </form>
        </div>
    </template>
    <script>
    import immiInput from "@/views/forms/fields/simpleinput.vue"
import { type } from "@amcharts/amcharts4/core";
    import moment from 'moment'
    export default {
      inject: ["parentValidator"],
      created() {
          this.$validator = this.parentValidator;
      },
      methods: {
        submitForm() {
             this.formErrors ='';
             this.$validator.validateAll("submittForm").then((result) => {
                if (result) {
                 let postData={
                "companyId": this.callFromPetitionerDetails? this.companyId : this.checkProperty(this.caseDetails, 'companyId'),
                "eVerifyClientId": this.eVerifyNumber 
                 }
                   this.loading =true;
                   let path ="/company/update-everify-client-id";
                   this.$store
                  .dispatch("commonAction", {"data":postData ,"path":path})
                  .then(response => {
                    this.$emit("updatepetition", "Success");
                    this.$emit("hideMe");  
                    this.showToster({message:response.message,isError:false });         
                  })
                  .catch((error)=>{
                    this.loading =false;
                    this.formErrors =error;
                  })
                }
              });
        },
        hideMe() {
          this.$emit("hideMe");
        },
      },
      watch: {
        showPopup(val) {
          if (!val) this.$emit("hideMe");
        },
      },
      mounted() {
        if(this.eVerifyUpdate){
          this.heading = 'Update I-9 E-Verify Client ID'
          this.eVerifyNumber = this.eVerifyID
        }
      },
      data: () => ({
        heading:'Add I-9 E-Verify Client ID',
        eVerifyNumber:null,
        formErrors:"",
        loading:false,
        showPopup: false,
        comments: '',
        formerrors: {
        msg: "",
        },
        }),
      props: {
        caseDetails: {
          type: Object,
          default: null,
        },
        companyId:{
            type:String,
            default:'',
        },
        callFromPetitionerDetails:{
            type: Boolean,
            default: false, 
        },
        eVerifyUpdate:{
          type:Boolean,
          default:false,
        },
        eVerifyID:{
          type:String,
          default:''
        }
      },
    components: {
      immiInput
    },
    };
    </script>